<template>
    <employees-show-page parent v-slot:default="_parent">
        <sub-item-show-view v-slot:default="_">
            <employee-adjustment-edit-form :disabled="_.itemDisabled" v-model="_.item" />
        </sub-item-show-view>
    </employees-show-page>
</template>

<script>
    import EmployeesShowPage from '../../show'
    import SubItemShowView from '../../../../Item/Views/SubItemShowView'
    import EmployeeAdjustmentEditForm from './Shared/EmployeeAdjustmentEditForm'

    export default {
        name: 'EmployeesShowAdjustmentsCreatePage',
        inheritAttrs: false,
        components: {
            EmployeeAdjustmentEditForm,
            EmployeesShowPage,
            SubItemShowView,
        },
    }
</script>

<style scoped>

</style>